export enum PumpType {
  AquathermPro = "aquathermPro",
  Aquatherm = "aquatherm",
  DaveyHeatPump = "daveyheatpump",
}

export interface PumpModel {
  model: string;
  soundLevel: string;
  length: string;
  width: string;
  height: string;
  netWeigth: string;
  powerSuply?: string;
  wifiSupport?: boolean;
  type: PumpType;
  onAir15: PumpCOP;
  onAir26?: PumpCOP;
}

interface PumpCOP {
  maximum: number;
  minimum: number;
  capacity50: number;
  capacity: number;
}

export const pumpModels: PumpModel[] = [
  {
    model: "DAT090",
    soundLevel: "40.0 - 52.4",
    length: "872",
    height: "654",
    width: "349",
    netWeigth: "46",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.Aquatherm,
    onAir15: {
      maximum: 6.8,
      minimum: 4.9,
      capacity50: 6.3,
      capacity: 6.3,
    },
    onAir26: {
      maximum: 12.6,
      minimum: 6.9,
      capacity50: 10.5,
      capacity: 9.0,
    },
  },
  {
    model: "DAT130",
    soundLevel: "41.9 - 52.9",
    length: "872",
    height: "654",
    width: "349",
    netWeigth: "49",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.Aquatherm,
    onAir15: {
      maximum: 7.1,
      minimum: 4.9,
      capacity50: 6.3,
      capacity: 8.5,
    },
    onAir26: {
      maximum: 13.2,
      minimum: 7.0,
      capacity50: 10.4,
      capacity: 12.5,
    },
  },
  {
    model: "DAT110",
    soundLevel: "36.3 - 44.5",
    length: "750",
    width: "530",
    height: "656",
    netWeigth: "66",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.AquathermPro,
    onAir15: {
      maximum: 7.5,
      minimum: 5.0,
      capacity50: 6.3,
      capacity: 7.7,
    },
    onAir26: {
      maximum: 15.0,
      minimum: 7.3,
      capacity50: 9.3,
      capacity: 11.5,
    },
  },
  {
    model: "DAT140",
    soundLevel: "36.5 - 45.9",
    length: "750",
    width: "530",
    height: "656",
    netWeigth: "73",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.AquathermPro,
    onAir15: {
      maximum: 7.6,
      minimum: 5.1,
      capacity50: 7.6,
      capacity: 9.3,
    },
    onAir26: {
      maximum: 15.0,
      minimum: 7.4,
      capacity50: 10.9,
      capacity: 14.0,
    },
  },
  {
    model: "DAT170",
    soundLevel: "39.3 - 46.7",
    length: "840",
    width: "530",
    height: "656",
    netWeigth: "75",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.AquathermPro,
    onAir15: {
      maximum: 7.8,
      minimum: 5.0,
      capacity50: 9.2,
      capacity: 11.5,
    },
    onAir26: {
      maximum: 15.0,
      minimum: 7.1,
      capacity50: 13.5,
      capacity: 17.0,
    },
  },
  {
    model: "DAT220",
    soundLevel: "39.5 - 49.8",
    length: "980",
    width: "530",
    height: "756",
    netWeigth: "91",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.AquathermPro,
    onAir15: {
      maximum: 8.2,
      minimum: 5.1,
      capacity50: 12.6,
      capacity: 15.0,
    },
    onAir26: {
      maximum: 15.5,
      minimum: 7.4,
      capacity50: 18.0,
      capacity: 22.5,
    },
  },
  {
    model: "DAT270",
    soundLevel: "39.8 - 50.2",
    length: "1135",
    width: "540",
    height: "756",
    netWeigth: "114",
    wifiSupport: true,
    powerSuply: "230V / 1Ph / 50Hz",
    type: PumpType.AquathermPro,
    onAir15: {
      maximum: 7.9,
      minimum: 5.2,
      capacity50: 14.4,
      capacity: 18.0,
    },
    onAir26: {
      maximum: 15.2,
      minimum: 7.2,
      capacity50: 20.6,
      capacity: 26.5,
    },
  },
];
